import React from 'react';
import { Typography, Box, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const SkillsList = ({ skills, onEdit, onDelete, compact = false }) => {
    if (!skills || skills.length === 0) {
        return (
            <Typography color="textSecondary" className="text-center py-4">
                No skills added yet
            </Typography>
        );
    }

    if (compact) {
        return (
            <Box>
                {skills.map(skill => (
                    <Box 
                        key={skill.id}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{ py: 1, borderBottom: '1px solid', borderColor: 'divider' }}
                    >
                        <Box>
                            <Typography variant="body1">
                                {skill.title}
                            </Typography>
                        </Box>
                        {(onEdit || onDelete) && (
                            <Box>
                                {onEdit && (
                                    <IconButton 
                                        size="small" 
                                        onClick={() => onEdit(skill)}
                                        sx={{ mr: 0.5 }}
                                    >
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                )}
                                {onDelete && (
                                    <IconButton 
                                        size="small" 
                                        color="error"
                                        onClick={() => onDelete(skill)}
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                )}
                            </Box>
                        )}
                    </Box>
                ))}
            </Box>
        );
    }

    return (
        <Box>
            {skills.map(skill => (
                <Box 
                    key={skill.id}
                    className="mb-4 p-3 border rounded"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="flex-start"
                >
                    <Box>
                        <Typography variant="subtitle1" className="font-semibold">
                            {skill.title}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            {skill.proficiencyLevel}
                        </Typography>
                        {skill.description && (
                            <Typography variant="body2" className="mt-1">
                                {skill.description}
                            </Typography>
                        )}
                    </Box>
                    {(onEdit || onDelete) && (
                        <Box>
                            {onEdit && (
                                <IconButton 
                                    size="small" 
                                    onClick={() => onEdit(skill)}
                                    className="mr-1"
                                >
                                    <EditIcon fontSize="small" />
                                </IconButton>
                            )}
                            {onDelete && (
                                <IconButton 
                                    size="small" 
                                    color="error"
                                    onClick={() => onDelete(skill)}
                                >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            )}
                        </Box>
                    )}
                </Box>
            ))}
        </Box>
    );
};

export default SkillsList; 